import global from "global";

export default href => {
  global.history.replaceState(null, "", href);
};
